/**
 * 菜单管理 Mock 数据
 */

import { MenuType, MenuItem, UserMenuItem } from '@/api/modules/menu';

// 模拟菜单数据 - 使用扁平结构（mock 数据允许宽松类型）
export const menuMockData: any[] = [
  // 仪表盘模块
  {
    id: '1001',
    name: 'Dashboard',
    title: '仪表盘',
    menu_type: 1, // 模块
    icon: 'DashboardOutlined',
    sort_order: 1,
    hide: 0, // 显示 (0否)
    keep_alive: 0, // 不缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2024-01-01 10:00:00',
    updated_at: '2024-12-15 15:30:00',
    tenant_type: 0, // 平台菜单
    locale: 'dashboard',
  },
  {
    id: '1002',
    parent_id: 1001,
    name: 'Workplace',
    title: '工作台',
    menu_type: 3, // 菜单
    path: '/dashboard/workplace',
    component: '/dashboard/workplace',
    icon: 'HomeOutlined',
    authority: 'dashboard:workplace:view',
    sort_order: 1,
    hide: 0, // 显示
    keep_alive: 1, // 缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2024-01-01 10:00:00',
    updated_at: '2024-12-15 15:30:00',
    parent_keys: ['/dashboard'],
    locale: 'workplace',
    tenant_type: 0, // 平台菜单
  },
  {
    id: '1003',
    parent_id: 1001,
    name: 'Analysis',
    title: '数据分析',
    menu_type: 3, // 菜单
    path: '/dashboard/analysis',
    component: '/dashboard/analysis',
    icon: 'AreaChartOutlined',
    authority: 'dashboard:analysis:view',
    sort_order: 2,
    hide: 0, // 显示
    keep_alive: 1, // 缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2024-01-01 10:00:00',
    updated_at: '2024-12-15 15:30:00',
    parent_keys: ['/dashboard'],
    locale: 'analysis',
    tenant_type: 0, // 平台菜单
  },
  
  // 系统管理模块
  {
    id: '2001',
    name: 'System',
    title: '系统管理',
    menu_type: 1, // 模块
    icon: 'SettingOutlined',
    sort_order: 10,
    hide: 0, // 显示
    keep_alive: 0, // 不缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2024-01-01 10:00:00',
    updated_at: '2024-12-15 15:30:00',
    locale: 'system',
    tenant_type: 0, // 平台菜单
  },
  {
    id: '2002',
    parent_id: 2001,
    name: 'UserList',
    title: '用户管理',
    menu_type: 3, // 菜单
    path: '/system/user',
    component: '/system/user',
    icon: 'UserOutlined',
    authority: 'system:user:view',
    sort_order: 1,
    hide: 0, // 显示
    keep_alive: 1, // 缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2024-01-01 10:00:00',
    updated_at: '2024-12-15 15:30:00',
    parent_keys: ['/system'],
    locale: 'userList',
    tenant_type: 0, // 平台菜单
  },
  {
    id: '2003',
    parent_id: 2002,
    name: 'user-add',
    title: '新增用户',
    menu_type: 4, // 节点/按钮
    authority: 'system:user:add',
    sort_order: 1,
    hide: 0, // 显示
    keep_alive: 0, // 不缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2024-01-01 10:00:00',
    updated_at: '2024-12-15 15:30:00',
    parent_keys: ['/system', '/system/user'],
    locale: 'userAdd',
    tenant_type: 0, // 平台菜单
  },
  {
    id: '2004',
    parent_id: 2002,
    name: 'user-edit',
    title: '编辑用户',
    menu_type: 4, // 节点/按钮
    authority: 'system:user:edit',
    sort_order: 2,
    hide: 0, // 显示
    keep_alive: 0, // 不缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2024-01-01 10:00:00',
    updated_at: '2024-12-15 15:30:00',
    parent_keys: ['/system', '/system/user'],
    locale: 'userEdit',
    tenant_type: 0, // 平台菜单
  },
  {
    id: '2005',
    parent_id: 2002,
    name: 'user-delete',
    title: '删除用户',
    menu_type: 4, // 节点/按钮
    authority: 'system:user:delete',
    sort_order: 3,
    hide: 0, // 显示
    keep_alive: 0, // 不缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2024-01-01 10:00:00',
    updated_at: '2024-12-15 15:30:00',
    parent_keys: ['/system', '/system/user'],
    locale: 'userDelete',
    tenant_type: 0, // 平台菜单
  },
  {
    id: '2006',
    parent_id: 2001,
    name: 'RoleList',
    title: '角色管理',
    menu_type: 3, // 菜单
    path: '/system/role',
    component: '/system/role',
    icon: 'SafetyCertificateOutlined',
    authority: 'system:role:view',
    sort_order: 2,
    hide: 0, // 显示
    keep_alive: 1, // 缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2024-01-01 10:00:00',
    updated_at: '2024-12-15 15:30:00',
    parent_keys: ['/system'],
    locale: 'roleList',
    tenant_type: 0, // 平台菜单
  },
  {
    id: '2007',
    parent_id: 2001,
    name: 'MenuList',
    title: '菜单管理',
    menu_type: 3, // 菜单
    path: '/system/menu',
    component: '/system/menu',
    icon: 'MenuOutlined',
    authority: 'system:menu:view',
    sort_order: 3,
    hide: 0, // 显示
    keep_alive: 1, // 缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2024-01-01 10:00:00',
    updated_at: '2024-12-15 15:30:00',
    parent_keys: ['/system'],
    locale: 'menuList',
    tenant_type: 0, // 平台菜单
  },
  {
    id: '2008',
    parent_id: 2001,
    name: 'TenantList',
    title: '租户管理',
    menu_type: 3, // 菜单
    path: '/system/tenant',
    component: '/system/tenant',
    icon: 'TeamOutlined',
    authority: 'system:tenant:view',
    sort_order: 4,
    hide: 0, // 显示
    keep_alive: 1, // 缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2025-01-01 10:00:00',
    updated_at: '2025-01-01 10:00:00',
    parent_keys: ['/system'],
    locale: 'tenantList',
    tenant_type: 0, // 平台菜单
  },
  {
    id: '2009',
    parent_id: 2008,
    name: 'tenant-add',
    title: '新增租户',
    menu_type: 4, // 节点/按钮
    authority: 'system:tenant:add',
    sort_order: 1,
    hide: 0, // 显示
    keep_alive: 0, // 不缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2025-01-01 10:00:00',
    updated_at: '2025-01-01 10:00:00',
    parent_keys: ['/system', '/system/tenant'],
    locale: 'tenantAdd',
    tenant_type: 0, // 平台菜单
  },
  {
    id: '2010',
    parent_id: 2008,
    name: 'tenant-edit',
    title: '编辑租户',
    menu_type: 4, // 节点/按钮
    authority: 'system:tenant:edit',
    sort_order: 2,
    hide: 0, // 显示
    keep_alive: 0, // 不缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2025-01-01 10:00:00',
    updated_at: '2025-01-01 10:00:00',
    parent_keys: ['/system', '/system/tenant'],
    locale: 'tenantEdit',
    tenant_type: 0, // 平台菜单
  },
  {
    id: '2011',
    parent_id: 2008,
    name: 'tenant-delete',
    title: '删除租户',
    menu_type: 4, // 节点/按钮
    authority: 'system:tenant:delete',
    sort_order: 3,
    hide: 0, // 显示
    keep_alive: 0, // 不缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2025-01-01 10:00:00',
    updated_at: '2025-01-01 10:00:00',
    parent_keys: ['/system', '/system/tenant'],
    locale: 'tenantDelete',
    tenant_type: 0, // 平台菜单
  },

  // 商品管理模块
  {
    id: '3001',
    name: 'Product',
    title: '商品管理',
    menu_type: 1, // 模块
    icon: 'ShoppingOutlined',
    sort_order: 3,
    hide: 0, // 显示
    keep_alive: 0, // 不缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2024-01-01 10:00:00',
    updated_at: '2024-12-15 15:30:00',
    locale: 'product',
    tenant_type: 0, // 平台菜单
  },
  {
    id: '3002',
    parent_id: 3001,
    name: 'ProductList',
    title: '商品列表',
    menu_type: 3, // 菜单
    path: '/product/list',
    component: '/product/list',
    icon: 'UnorderedListOutlined',
    authority: 'product:list:view',
    sort_order: 1,
    hide: 0, // 显示
    keep_alive: 1, // 缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2024-01-01 10:00:00',
    updated_at: '2024-12-15 15:30:00',
    parent_keys: ['/product'],
    locale: 'productList',
    tenant_type: 0, // 平台菜单
  },
  {
    id: '3003',
    parent_id: 3001,
    name: 'CategoryList',
    title: '分类管理',
    menu_type: 3, // 菜单
    path: '/product/category',
    component: '/product/category',
    icon: 'AppstoreOutlined',
    authority: 'product:category:view',
    sort_order: 2,
    hide: 0, // 显示
    keep_alive: 1, // 缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2024-01-01 10:00:00',
    updated_at: '2024-12-15 15:30:00',
    parent_keys: ['/product'],
    locale: 'categoryList',
    tenant_type: 0, // 平台菜单
  },
  {
    id: '3004',
    parent_id: 3001,
    name: 'BrandList',
    title: '品牌管理',
    menu_type: 3, // 菜单
    path: '/product/brand',
    component: '/product/brand',
    icon: 'SketchOutlined',
    authority: 'product:brand:view',
    sort_order: 3,
    hide: 0, // 显示
    keep_alive: 1, // 缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2025-11-06 10:00:00',
    updated_at: '2025-11-06 10:00:00',
    parent_keys: ['/product'],
    locale: 'brandList',
    tenant_type: 0, // 平台菜单
  },
  {
    id: '3005',
    parent_id: 3001,
    name: 'SpuList',
    title: 'SPU管理',
    menu_type: 3, // 菜单
    path: '/product/spu',
    component: '/product/spu',
    icon: 'TagsOutlined',
    authority: 'product:spu:view',
    sort_order: 4,
    hide: 0, // 显示
    keep_alive: 1, // 缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2025-11-06 10:00:00',
    updated_at: '2025-11-06 10:00:00',
    parent_keys: ['/product'],
    locale: 'spuList',
    tenant_type: 0, // 平台菜单
  },
  {
    id: '3006',
    parent_id: 3001,
    name: 'SkuList',
    title: 'SKU管理',
    menu_type: 3, // 菜单
    path: '/product/sku',
    component: '/product/sku',
    icon: 'BarcodeOutlined',
    authority: 'product:sku:view',
    sort_order: 5,
    hide: 0, // 显示
    keep_alive: 1, // 缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2025-11-06 10:00:00',
    updated_at: '2025-11-06 10:00:00',
    parent_keys: ['/product'],
    locale: 'skuList',
    tenant_type: 0, // 平台菜单
  },

  // 任务管理模块
  {
    id: '3500',
    name: 'Task',
    title: '任务管理',
    menu_type: 0, // 目录/模块
    path: '/task',
    component: 'RouteView',
    icon: 'ThunderboltOutlined',
    sort_order: 5,
    hide: 0, // 显示
    keep_alive: 0, // 不缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2025-01-05 10:00:00',
    updated_at: '2025-01-05 10:00:00',
    locale: 'task',
    tenant_type: 0, // 平台菜单
  },
  {
    id: '3501',
    parent_id: 3500,
    name: 'ExportTaskList',
    title: '导出任务',
    menu_type: 1, // 菜单项
    path: '/task/export',
    component: '/task/export',
    icon: 'ExportOutlined',
    authority: 'task:export:view',
    sort_order: 1,
    hide: 0, // 显示
    keep_alive: 1, // 缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2025-01-05 10:00:00',
    updated_at: '2025-01-05 10:00:00',
    parent_keys: ['/task'],
    locale: 'exportTask',
    tenant_type: 0, // 平台菜单
  },
  {
    id: '3502',
    parent_id: 3500,
    name: 'BatchTaskList',
    title: '批量任务',
    menu_type: 1, // 菜单项
    path: '/task/batch',
    component: '/task/batch',
    icon: 'UploadOutlined',
    authority: 'task:batch:view',
    sort_order: 2,
    hide: 0, // 显示
    keep_alive: 1, // 缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2025-01-05 10:00:00',
    updated_at: '2025-01-05 10:00:00',
    parent_keys: ['/task'],
    locale: 'batchTask',
    tenant_type: 0, // 平台菜单
  },
  {
    id: '3503',
    parent_id: 3500,
    name: 'ScheduleCenter',
    title: '调度中心',
    menu_type: 1,
    path: '/task/schedules',
    component: '/task/schedules',
    icon: 'FieldTimeOutlined',
    authority: '',
    sort_order: 0,
    hide: 0,
    keep_alive: 1,
    target: 0,
    status: 1,
    created_at: '2026-08-04 10:00:00',
    updated_at: '2026-08-04 10:00:00',
    parent_keys: ['/task'],
    locale: 'scheduleCenter',
    tenant_type: 0,
  },

  // 订单管理模块
  {
    id: '4001',
    name: 'Order',
    title: '订单管理',
    menu_type: 1, // 模块
    icon: 'ProfileOutlined',
    sort_order: 4,
    hide: 0, // 显示
    keep_alive: 0, // 不缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2024-01-01 10:00:00',
    updated_at: '2024-12-15 15:30:00',
    locale: 'order',
    tenant_type: 0, // 平台菜单
  },
  {
    id: '4002',
    parent_id: 4001,
    name: 'OrderList',
    title: '订单列表',
    menu_type: 3, // 菜单
    path: '/oms/sales-order',
    component: '/oms/sales-order',
    icon: 'OrderedListOutlined',
    authority: 'order:list:view',
    sort_order: 1,
    hide: 0, // 显示
    keep_alive: 1, // 缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2024-01-01 10:00:00',
    updated_at: '2024-12-15 15:30:00',
    parent_keys: ['/order'],
    locale: 'orderList',
    tenant_type: 0, // 平台菜单
  },

  // 订单审批与统计
  {
    id: '5003',
    name: 'PendingApprovalList',
    title: '待审批订单',
    menu_type: 3, // 菜单
    path: '/order/pending-approval',
    component: '/order/pending-approval',
    icon: 'AuditOutlined',
    authority: 'business:order:approve',
    sort_order: 2,
    hide: 0, // 显示
    keep_alive: 1, // 缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2025-11-02 10:00:00',
    updated_at: '2025-11-02 10:00:00',
    parent_keys: ['/order'],
    locale: 'pendingApprovalList',
    tenant_type: 0, // 平台菜单
  },
  {
    id: '5004',
    name: 'OrderStatistics',
    title: '订单统计',
    menu_type: 3, // 菜单
    path: '/order/statistics',
    component: '/order/statistics',
    icon: 'BarChartOutlined',
    authority: 'business:order:statistics',
    sort_order: 3,
    hide: 0, // 显示
    keep_alive: 1, // 缓存
    target: 0, // 组件打开方式
    status: 1, // 正常
    created_at: '2025-11-02 10:00:00',
    updated_at: '2025-11-02 10:00:00',
    parent_keys: ['/order'],
    locale: 'orderStatistics',
    tenant_type: 0, // 平台菜单
  },

   {"id":"1712","parent_id":1702,"title":"品牌","icon":"SketchOutlined","path":"/product/brand","component":"/product/brand","target":0,"authority":"product:brand","menu_type":1,"hide":0,"keep_alive":0,"locale":"","parent_keys":[],"name":"ProductBrand","redirect":""},
   {"id":"1888","parent_id":1823,"title":"库存分配","icon":"IdcardOutlined","path":"/cms/stock-allocation","component":"/cms/stock-allocation","target":0,"authority":"cms:stock-allocation","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"","redirect":""},

];

// 获取所有菜单数据
export function getMenuList(params?: any) {
  // 已经是扁平结构，直接使用
  let result = [...menuMockData];

  // 根据参数过滤数据
  if (params) {
    if (params.name && typeof params.name === 'string') {
      const nameToFilter = params.name.toLowerCase();
      result = result.filter(item => 
        item.name && typeof item.name === 'string' && item.name.toLowerCase().includes(nameToFilter)
      );
    }
    
    if (params.title && typeof params.title === 'string') {
      const titleToFilter = params.title.toLowerCase();
      result = result.filter(item => 
        item.title && typeof item.title === 'string' && item.title.toLowerCase().includes(titleToFilter)
      );
    }
    
    if (params.type !== undefined) {
      // 将枚举类型转换为menu_type进行过滤
      let menuTypeValue: number | undefined;
      const paramType = params.type as MenuType; // 明确类型
      switch (paramType) {
        case MenuType.DIRECTORY:
          menuTypeValue = 1; // 模块/导航
          break;
        case MenuType.MENU:
          menuTypeValue = 3; // 菜单
          break;
        case MenuType.BUTTON:
          menuTypeValue = 4; // 节点/按钮
          break;
      }

      if (menuTypeValue !== undefined) {
        result = result.filter(item => item.menu_type === menuTypeValue);
      }
    }
    
    if (params.isVisible !== undefined) {
      // isVisible 为 true 时对应 hide 为 0
      const hideValue = params.isVisible ? 0 : 1;
      result = result.filter(item => item.hide === hideValue);
    }
    
    // 使用正确的parent_id字段进行过滤
    if (params.parentId) {
      result = result.filter(item => 
        item.parent_id === Number(params.parentId)
      );
    }
    
    // 处理分页
    if (params.current && params.pageSize) {
      const startIndex = (params.current - 1) * params.pageSize;
      const endIndex = startIndex + params.pageSize;
      result = result.slice(startIndex, endIndex);
    }
  }

  // 添加适配器转换，使返回数据与旧字段名兼容

  return {
    data: result ,
    count: menuMockData.length,
    success: true,
  };
}

// 菜单数据已经是扁平结构，不需要展平处理
function getMenus(): any[] {
  // 直接返回菜单数据
  return menuMockData;
}

// 将menu_type数值转换为MenuType枚举 - 用于API层转换
function getTypeFromMenuType(menuType?: number): MenuType {
  if (menuType === undefined) return MenuType.MENU;
  
  switch (menuType) {
    case 1: // 模块
    case 2: // 导航
      return MenuType.DIRECTORY;
    case 3: // 菜单
      return MenuType.MENU;
    case 4: // 节点
      return MenuType.BUTTON;
    default:
      return MenuType.MENU;
  }
}

// 获取菜单树数据
export function getMenuTree(params?: { includeButtons?: boolean }) {
  let result = [...menuMockData];
  
  if (params && params.includeButtons === false) {
    // 过滤掉按钮类型的菜单
    result = result.filter(item => item.menu_type !== 4); // 过滤掉节点/按钮类型
  }
  
  // 转换为前端需要的格式，不需要构建树形结构
  // 由于我们不再使用适配器转换，直接返回原始数据
  return {
    data: result,
    success: true,
  };
}

// 获取菜单详情
export function getMenuDetail(id: string) {
  const menu = menuMockData.find(item => item.id === id);
  
  // 不再使用适配器转换，直接返回原始数据
  return {
    data: menu,
    success: !!menu,
  };
}

// 创建菜单
export function createMenu(data: Partial<MenuItem>) {
  const newMenu: any = {
    id: Date.now(),
    name: data.name || '',
    title: data.title || '',
    menu_type: data.menu_type || 3,
    path: data.path,
    component: data.component,
    icon: data.icon,
    authority: data.authority,
    sort_order: data.sort_order || 0,
    hide: data.hide !== undefined ? data.hide : 0,
    keep_alive: data.keep_alive !== undefined ? data.keep_alive : 0,
    target: data.target || 0,
    redirect: data.redirect,
    parent_id: data.parent_id || 0,
    status: data.status || 1,
    locale: data.locale,
    created_at: new Date().toISOString().replace('T', ' ').split('.')[0],
    updated_at: new Date().toISOString().replace('T', ' ').split('.')[0],
  };
  
  // 在实际项目中这里应该把新菜单添加到数据源中
  // 这里模拟添加成功
  
  return {
    data: newMenu,
    success: true,
  };
}

// 更新菜单
export function updateMenu(id: string, data: Partial<MenuItem>) {
  const index = menuMockData.findIndex(item => item.id === id);
  const menu = index !== -1 ? menuMockData[index] : null;
  
  if (!menu) {
    return {
      data: null,
      success: false,
      message: '菜单不存在',
    };
  }
  
  // 更新菜单属性，只使用新的字段名
  const updatedMenu = {
    ...menu,
    ...data,
    updated_at: new Date().toISOString().replace('T', ' ').split('.')[0],
  };
  
  // 更新数组中的对象
  menuMockData[index] = updatedMenu;
  
  return {
    data: updatedMenu,
    success: true,
  };
}

// 删除菜单
export function deleteMenu(id: string) {
  // 在实际项目中应该从数据源中删除菜单
  // 这里模拟删除成功
  return {
    success: true,
  };
}

export function getMenuUser() {
    // 模拟用户菜单数据 - 使用扁平结构
    const userMenuMockData: any[] = [
        {"id":1001,"parent_id":0,"title":"仪表盘","icon":"DashboardOutlined","path":"/dashboard","component":"RouteView","target":0,"authority":"","menu_type":0,"hide":0,"keep_alive":0,"locale":"","parent_keys":[],"name":"Dashboard","redirect":""},
        {"id":1002,"parent_id":1001,"title":"工作台","icon":"DesktopOutlined","path":"/dashboard/workplace","component":"/dashboard/workplace","target":0,"authority":"","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":["/dashboard"],"name":"Workplace","redirect":""},
        {"id":1738,"parent_id":1723,"title":"销售订单","icon":"ProfileOutlined","path":"/oms/sales-order","component":"/oms/sales-order","target":0,"authority":"oms:sales-order","menu_type":1,"hide":0,"keep_alive":0,"locale":"","parent_keys":[],"name":"/oms/sales-order","redirect":""},
        {"id":1741,"parent_id":1738,"title":"查看","icon":"","path":"/oms/sales-order/show","component":"oms/sales-order/show","target":0,"authority":"oms:sales-order:show","menu_type":1,"hide":1,"keep_alive":0,"locale":"","parent_keys":["/oms/sales-order"],"name":"/oms/sales-order/show","redirect":""},
        {"id":1755,"parent_id":0,"title":"财务管理","icon":"MoneyCollectOutlined","path":"/finance","component":"RouteView","target":0,"authority":"","menu_type":0,"hide":0,"keep_alive":0,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":1756,"parent_id":1755,"title":"账户主体","icon":"BookOutlined","path":"/finance/account/entity","component":"/finance/account/entity","target":0,"authority":"","menu_type":1,"hide":0,"keep_alive":0,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":5,"parent_id":4,"title":"员工管理","icon":"UserOutlined","path":"/system/user","component":"/system/user","target":0,"authority":"sys:user:view","menu_type":1,"hide":0,"keep_alive":0,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":13,"parent_id":4,"title":"角色管理","icon":"AppstoreAddOutlined","path":"/system/role","component":"/system/role","target":0,"authority":"sys:role","menu_type":1,"hide":0,"keep_alive":0,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":14,"parent_id":4,"title":"菜单管理","icon":"AppstoreAddOutlined","path":"/system/menu","component":"/system/menu","target":0,"authority":"sys:menu","menu_type":1,"hide":0,"keep_alive":0,"locale":"","parent_keys":[],"name":"","redirect":""},

        {"id":36,"parent_id":4,"title":"岗位管理","icon":"PicLeftOutlined","path":"/system/position","component":"/system/position","target":0,"authority":"sys:position","menu_type":1,"hide":0,"keep_alive":0,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":43,"parent_id":4,"title":"部门管理","icon":"TableOutlined","path":"/system/organization","component":"/system/organization","target":0,"authority":"sys:dept","menu_type":1,"hide":0,"keep_alive":0,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":1392,"parent_id":4,"title":"用户信息","icon":"UserSwitchOutlined","path":"/system/user/info","component":"/system/user/info","target":0,"authority":"","menu_type":1,"hide":1,"keep_alive":0,"locale":"","parent_keys":["[\"22\"]"],"name":"","redirect":""},
        {"id":1525,"parent_id":5,"title":"员工详情","icon":"UserOutlined","path":"/system/user/details","component":"/system/user/details","target":0,"authority":"","menu_type":0,"hide":1,"keep_alive":0,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":1723,"parent_id":0,"title":"订单管理","icon":"ProfileOutlined","path":"/oms","component":"RouteView","target":0,"authority":"","menu_type":0,"hide":0,"keep_alive":0,"locale":"","parent_keys":[],"name":"/oms","redirect":""},
        {"id":1702,"parent_id":0,"title":"商品管理","icon":"TableOutlined","path":"/product","component":"RouteView","target":0,"authority":"","menu_type":0,"hide":0,"keep_alive":0,"locale":"","parent_keys":[],"name":"Product","redirect":""},
        {"id":1703,"parent_id":1702,"title":"商品信息","icon":"BarcodeOutlined","path":"/product/list","component":"/product/list","target":0,"authority":"pms:spu:list","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"ProductProduct","redirect":""},
        {"id":1707,"parent_id":1702,"title":"商品分类","icon":"AppstoreAddOutlined","path":"/product/category","component":"/product/category","target":0,"authority":"product:category","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"ProductCategory","redirect":""},
        {"id":1712,"parent_id":1702,"title":"品牌","icon":"SketchOutlined","path":"/product/brand","component":"/product/brand","target":0,"authority":"product:brand","menu_type":1,"hide":0,"keep_alive":0,"locale":"","parent_keys":[],"name":"ProductBrand","redirect":""},
        {"id":3005,"parent_id":1702,"title":"SPU管理","icon":"TagsOutlined","path":"/product/spu","component":"/product/spu","target":0,"authority":"product:spu:view","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"SpuList","redirect":""},
        {"id":3006,"parent_id":1702,"title":"SKU管理","icon":"BarcodeOutlined","path":"/product/sku","component":"/product/sku","target":0,"authority":"product:sku:view","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"SkuList","redirect":""},
        {"id":1728,"parent_id":4,"title":"快递公司","icon":"CarOutlined","path":"/system/express","component":"/system/express","target":0,"authority":"sys:express","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"SystemDelivery","redirect":""},
        {"id":1739,"parent_id":1738,"title":"创建","icon":"ProfileOutlined","path":"/oms/sales-order/add","component":"/oms/sales-order/edit","target":0,"authority":"oms:sales-order:add","menu_type":1,"hide":1,"keep_alive":1,"locale":"","parent_keys":["/oms/sales-order"],"name":"AddSalesOrder","redirect":""},
        {"id":1743,"parent_id":1738,"title":"编辑","icon":"FileSearchOutlined","path":"/oms/sales-order/edit","component":"/oms/sales-order/edit","target":0,"authority":"oms:sales-order:edit","menu_type":1,"hide":1,"keep_alive":1,"locale":"","parent_keys":["/oms/sales-order"],"name":"","redirect":""},
        {"id":1757,"parent_id":1755,"title":"账户管理","icon":"BookOutlined","path":"/finance/account","component":"/finance/account/account","target":0,"authority":"","menu_type":1,"hide":0,"keep_alive":0,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":1758,"parent_id":1755,"title":"交易流水","icon":"InteractionOutlined","path":"/finance/transaction","component":"/finance/transaction","target":0,"authority":"","menu_type":1,"hide":0,"keep_alive":0,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":1822,"parent_id":1702,"title":"销售渠道","icon":"ApartmentOutlined","path":"/product/sales-channel","component":"/product/sales-channel","target":0,"authority":"product:sales-channel","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"ProductSalesChannel","redirect":""},
        {"id":1823,"parent_id":0,"title":"客户管理","icon":"TeamOutlined","path":"/cms","component":"RouteView","target":0,"authority":"","menu_type":0,"hide":0,"keep_alive":0,"locale":"","parent_keys":[],"name":"Customer","redirect":""},
        {"id":1824,"parent_id":1823,"title":"客户信息","icon":"UserOutlined","path":"/cms/info","component":"/cms/customer-info","target":0,"authority":"cms:customer-info","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"CustomerInfo","redirect":""},
        {"id":1825,"parent_id":1823,"title":"客户报价","icon":"TagOutlined","path":"/cms/customer-quote","component":"/cms/customer-quote","target":0,"authority":"customer:customer-quote","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"CustomerQuote","redirect":""},
        {"id":1826,"parent_id":1823,"title":"客户类型","icon":"IdcardOutlined","path":"/cms/customer-type","component":"/cms/customer-type","target":0,"authority":"cms:customer-type","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":1888,"parent_id":1823,"title":"库存分配","icon":"IdcardOutlined","path":"/cms/stock-allocation","component":"/cms/stock-allocation","target":0,"authority":"cms:stock-allocation","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"","redirect":""},

        {"id":1827,"parent_id":1702,"title":"渠道商品管理","icon":"BlockOutlined","path":"/pms/channel-product","component":"/product/channel-product","target":0,"authority":"pms:channel-product","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":1828,"parent_id":1702,"title":"渠道客户商品","icon":"ProfileOutlined","path":"/pms/channel-customer-product","component":"/product/channel-customer-product","target":0,"authority":"pms:channel-customer-product","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":1829,"parent_id":1702,"title":"网店库存","icon":"ProfileOutlined","path":"/pms/inventory","component":"/product/inventory","target":0,"authority":"pms:inventory","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":1830,"parent_id":4,"title":"仓库设置","icon":"BankOutlined","path":"/system/warehouse","component":"/system/warehouse","target":0,"authority":"sys:warehouse","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":1831,"parent_id":4,"title":"仓库快递","icon":"CarOutlined","path":"/system/warehouse-express","component":"/system/warehouse-express","target":0,"authority":"sys:warehouse-express","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":1836,"parent_id":4,"title":"审批设置","icon":"ApartmentOutlined","path":"/system/approval-workflow","component":"/system/approval-workflow","target":0,"authority":"sys:approval-workflow","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":1843,"parent_id":0,"title":"协同仓","icon":"InteractionOutlined","path":"shared-inventory","component":"RouteView","target":0,"authority":"","menu_type":0,"hide":0,"keep_alive":0,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":1844,"parent_id":1843,"title":"客户剩余库存","icon":"AppstoreOutlined","path":"/shared-inventory/remaining-stock","component":"/shared-inventory/remaining-stock","target":0,"authority":"","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":1845,"parent_id":1843,"title":"客户共享库存","icon":"TableOutlined","path":"/shared-inventory/shared-stock","component":"/shared-inventory/shared-stock","target":0,"authority":"","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":1846,"parent_id":1843,"title":"寻源单","icon":"IdcardOutlined","path":"/shared-inventory/sourcing-orders","component":"/shared-inventory/sourcing-orders","target":0,"authority":"","menu_type":1,"hide":0,"keep_alive":0,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":1847,"parent_id":1702,"title":"网店设置","icon":"LinkOutlined","path":"/pms/store","component":"/product/store","target":0,"authority":"pms:store:list","menu_type":1,"hide":0,"keep_alive":0,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":1872,"parent_id":1702,"title":"渠道货盘管理","icon":"AppstoreOutlined","path":"/pms/channel-inventory","component":"/product/channel-inventory","target":0,"authority":"pms:channel-inventory","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":1875,"parent_id":1702,"title":"客户货盘管理","icon":"FileTextOutlined","path":"/pms/customer-inventory","component":"/product/customer-inventory","target":0,"authority":"pms:customer-inventory:list","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":1877,"parent_id":1825,"title":"报价","icon":"","path":"/cms/customer-quote/quote","component":"/cms/customer-quote/quote","target":0,"authority":"cms:customer-quote:quote","menu_type":1,"hide":1,"keep_alive":1,"locale":"","parent_keys":["/cms/customer-quote"],"name":"","redirect":""},
        {"id":1885,"parent_id":1702,"title":"渠道库位管理","icon":"AppstoreAddOutlined","path":"/pms/channel-location","component":"/product/channel-location","target":0,"authority":"pms:channel-location","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":1890,"parent_id":1702,"title":"大类起运模版","icon":"CarOutlined","path":"/product/category-shipment-templates","component":"/product/category-shipment-templates","target":0,"authority":"product:category-shipment-templates","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":[],"name":"CategoryShipmentTemplateList","redirect":""},
        {"id":3500,"parent_id":0,"title":"任务管理","icon":"ThunderboltOutlined","path":"/task","component":"RouteView","target":0,"authority":"","menu_type":0,"hide":0,"keep_alive":0,"locale":"","parent_keys":[],"name":"Task","redirect":""},
        {"id":3501,"parent_id":3500,"title":"导出任务","icon":"ExportOutlined","path":"/task/export","component":"/task/export","target":0,"authority":"task:export:view","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":["/task"],"name":"ExportTaskList","redirect":""},
        {"id":3502,"parent_id":3500,"title":"批量任务","icon":"UploadOutlined","path":"/task/batch","component":"/task/batch","target":0,"authority":"task:batch:view","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":["/task"],"name":"BatchTaskList","redirect":""},
        {"id":3503,"parent_id":3500,"title":"调度中心","icon":"FieldTimeOutlined","path":"/task/schedules","component":"/task/schedules","target":0,"authority":"","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":["/task"],"name":"ScheduleCenter","redirect":""},
        {"id":4,"parent_id":0,"title":"系统管理","icon":"ControlOutlined","path":"/system","component":"RouteView","target":0,"authority":"","menu_type":0,"hide":0,"keep_alive":0,"locale":"","parent_keys":[],"name":"","redirect":""},
        {"id":4000,"parent_id":0,"title":"仓库管理","icon":"BankOutlined","path":"/warehouse","component":"RouteView","target":0,"authority":"","menu_type":0,"hide":0,"keep_alive":0,"locale":"","parent_keys":[],"name":"Warehouse","redirect":""},
        {"id":4001,"parent_id":4000,"title":"仓库列表","icon":"BankOutlined","path":"/warehouse/list","component":"/warehouse/list","target":0,"authority":"warehouse:list","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":["/warehouse"],"name":"WarehouseList","redirect":""},
        {"id":4002,"parent_id":4000,"title":"库存管理","icon":"DatabaseOutlined","path":"/warehouse/inventory","component":"/warehouse/inventory","target":0,"authority":"warehouse:inventory","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":["/warehouse"],"name":"WarehouseInventory","redirect":""},
        {"id":4003,"parent_id":4000,"title":"入库管理","icon":"ImportOutlined","path":"/warehouse/inbound","component":"/warehouse/inbound","target":0,"authority":"warehouse:inbound","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":["/warehouse"],"name":"WarehouseInbound","redirect":""},
        {"id":4004,"parent_id":4000,"title":"出库管理","icon":"ExportOutlined","path":"/warehouse/outbound","component":"/warehouse/outbound","target":0,"authority":"warehouse:outbound","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":["/warehouse"],"name":"WarehouseOutbound","redirect":""},
        {"id":4005,"parent_id":4000,"title":"仓库单据","icon":"FileTextOutlined","path":"/warehouse/receipt","component":"/warehouse/receipt","target":0,"authority":"warehouse:receipt","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":["/warehouse"],"name":"WarehouseReceipt","redirect":""},
        {"id":4006,"parent_id":4000,"title":"仓库权限","icon":"LockOutlined","path":"/warehouse/permissions","component":"/warehouse/permissions","target":0,"authority":"warehouse:permissions","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":["/warehouse"],"name":"WarehousePermissions","redirect":""},
        {"id":4007,"parent_id":4000,"title":"仓库快递配置","icon":"CarOutlined","path":"/warehouse/carrier-config","component":"/warehouse/carrier-config","target":0,"authority":"warehouse:carrier-config","menu_type":1,"hide":0,"keep_alive":1,"locale":"","parent_keys":["/warehouse"],"name":"WarehouseCarrierConfig","redirect":""}
      ];
      return userMenuMockData;
}
